export const hasNestedProperty = (obj: unknown, keyPath: string): boolean => {
    if (typeof obj !== "object" || obj === null) return false;

    let current: unknown = obj;

    for (const key of keyPath.split(".")) {
        if (
            typeof current === "object" &&
            current !== null &&
            key in (current as Record<string, unknown>)
        ) {
            current = (current as Record<string, unknown>)[key];
        } else {
            return false;
        }
    }

    return true;
}

export function removeZerosForSpecificFields<T extends Record<string, any>>(
    obj: T,
    keysToUpdate: (keyof T)[],
): T {
    const updatedObj: T = { ...obj };

    keysToUpdate.forEach(key => {
        if (key in updatedObj) {
            updatedObj[key] = updatedObj[key].replace(/^0+/, "");
        }
    });

    return updatedObj;
}